<template>
	<div class="site-not-available-wrapper">
		<div class="bilka-top-text">tilgængeligt</div>
		<div class="bilka-logo-disable-page">
			<img src="~@static/tid2/favicon/apple-icon-167x167.png"/>
		</div>
		<div class="bilka">
			<div class="bil-brocken">
				Websitet er midlertidigt ikke tilgængeligt
			</div>
			<div class="bil-brocken-sub">
				<template v-if="platform === ''">
					{{tenantSettings.tenantUnavailableCustomText ? tenantSettings.tenantUnavailableCustomText : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
				<template v-else-if="platform === 'android'">
					{{tenantSettings.tenantUnavailableCustomTextAndroid ? tenantSettings.tenantUnavailableCustomTextAndroid : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
				<template v-else-if="platform === 'ios'">
					{{tenantSettings.tenantUnavailableCustomTextIos ? tenantSettings.tenantUnavailableCustomTextIos : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
			</div>
			<div class="center-button-align"><v-btn @click="siteNotAvailableRedirect" flat class="bilka-btn">Gå til Bilka.dk</v-btn></div>
		</div>
		<div class="fotex-bottom smag-bottom">tilgængeligt</div>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";
	export default {
		name: "SiteNotAvailableTid2",
		props: ["siteNotAvailableRedirect", "platform"],
		computed: {
			...mapGetters(["tenantSettings"])
		}
	};
</script>

<style scoped>

</style>
